"use strict";
import { StateManager } from "../../js/states/statemanager";
import { TooltipManager } from "../../js/helpers/tooltipmanager";
import { SOCKETABLE_ITEM_TYPES } from "../../js/gamedata/inventorydata";

ui.loadTemplateFile("inventory.html");

class InventoryDialog extends Dialog {
    _element: any;
    _titleBar: any;
    _pageTabs: any;
    _inventoryTabs: any;
    _inventorySlots: any[];
    _patInventorySlots: any[];
    _ammoSlots: any[];
    _equipSlots: any[];
    _patSlots: any[];
    _equippedTab: any;
    _data: any;

    // The server stores Weapon at 138 and Ability at 139, while the UI
    // displays Ability before Weapon.
    static PAT_SLOTS = [135, 136, 137, 139, 138];

    constructor(inventory: any) {
        super("inventory.html");

        this._pageTabs = ui.tabpanel(this, ".tabpanel.page");
        this._inventoryTabs = ui.tabpanel(this, ".tabpanel.inventory");
        this._inventorySlots = [];
        this._patInventorySlots = [];
        this._ammoSlots = [];
        this._equipSlots = [];
        this._patSlots = [];

    for (let i = 1; i <= 90; ++i) {
        let id = ".inventory-slot-" + i;
        const page = Math.floor((i - 1) / 30);
        const tab = this._inventoryTabs.tab(page);
        let slot = ui.iconslot(id);
        slot.acceptsItem(true);
        tab.append(slot);

        if (i > 0 && i % 6 === 0) {
            tab._element.append("<br />");
        }

        slot.on("swap", this._swapSlot.bind(this, slot));
        this._inventorySlots.push(slot);
    }

    const patInventoryTab = this._pageTabs.tab(1);
    for (let i = 90; i < 120; ++i) {
        const slot = ui.iconslot(".inventory-slot-" + (i + 1));
        slot.acceptsItem(true);
        patInventoryTab.append(slot);
        if ((i - 89) % 6 === 0) patInventoryTab._element.append("<br />");
        slot.on("swap", this._swapSlot.bind(this, slot));
        this._patInventorySlots.push(slot);
        this._inventorySlots[i] = slot;
    }

    this._equippedTab = this._pageTabs.tab(0);

    const equipText = [
        "Face", // 0
        "Head", // 1
        "Armor", // 2
        "Back", // 3
        "Arms", // 4
        "Boots", // 5
        "Weapon", // 6
        "Shield", // 7
        "Necklace", // 8
        "Ring", // 9
        "Earring", // 10
    ];
    for (let i = 1; i <= 11; ++i) {
        let id = ".equip-slot-" + i;
        let slot = ui.iconslot(this._equippedTab, id);
        slot.text(equipText[i - 1]);
        slot.acceptsItem(true);
        slot.on("swap", this._swapSlot.bind(this, slot));
        this._equipSlots[i] = slot;
    }

    const ammoText = ["Arrow", "Bullet", "Cannon"];
    for (let i = 0; i < 3; ++i) {
        const id = ".ammo-slot-" + i;
        const slot = ui.iconslot(this._equippedTab, id);
        slot.text(ammoText[i]);
        slot.acceptsItem(true);
        slot.on("swap", this._swapSlot.bind(this, slot));
        this._ammoSlots[i] = slot;
    }

    const patTab = this._pageTabs.tab(1);
    const patText = ["Body", "Engine", "Wheels", "Ability", "Weapon"];
    for (let i = 0; i < 5; ++i) {
        const id = ".pat-slot-" + i;
        const slot = ui.iconslot(patTab, id);
        slot.text(patText[i]);
        slot.acceptsItem(true);
        slot.on("swap", this._swapSlot.bind(this, slot));
        this._patSlots[i] = slot;
    }

        this._data = inventory;
        this._data.on("changed", this._update.bind(this));
        if (typeof MC !== 'undefined' && MC) {
            MC.on('changed', () => this._updatePatStats(GDM.getNow('item_data')));
        }
        this._update();
    }

    _swapSlot(srcSlot: any, dst: any) {
        TooltipManager.hideTooltip();
        let item = srcSlot.icon();

        // Drop item
        if (dst === "drop") {
            this._data.dropItem(item);
            return;
        }

        const dstLocInfo = getItemLocationFromName(dst);

        if (!dstLocInfo) {
            // Move to quickbar
            const match = dst.match(/^quick-slot-([0-9]*)$/);

            if (match) {
                let slot = this._data.getSlotFromLocSlot(
                    item.location,
                    item.slotNo
                );
                if (slot) {
                    netGame.setHotIcon(match[1], HOT_ICON_TYPE.ITEM, slot);
                }
                return;
            }

            // Offer to a trade
            const tradeMatch = dst.match(/^trade-my-slot-([0-9]*)$/);
            if (tradeMatch && item.location === ITEMLOC.INVENTORY) {
                netGame.tradeAddItem(item.slotNo + 12);
                return;
            }

            // Offer to vending (Selling or Buying tab)
            const vendingSellMatch = dst.match(/^vending-sell-slot-([0-9]*)$/);
            if (vendingSellMatch && item.location === ITEMLOC.INVENTORY) {
                StateManager.get('game').gameUI.vending.onItemDroppedOnSell(item);
                return;
            }
            const vendingBuyMatch = dst.match(/^vending-buy-slot-([0-9]*)$/);
            if (vendingBuyMatch && item.location === ITEMLOC.INVENTORY) {
                StateManager.get('game').gameUI.vending.onItemDroppedOnBuy(item);
                return;
            }
            const npcStoreBuyMatch = dst.match(/^npcstore-buy-slot-([0-9]*)$/);
            if (npcStoreBuyMatch && item.location === ITEMLOC.INVENTORY) {
                StateManager.get('game').gameUI.npcStore.onItemDroppedOnSell(item);
                return;
            }
            return;
        }

        const dstLocation = dstLocInfo.location;

        // Gem dropped on a jewel/weapon/offhand with a free socket: socket it.
        if (item.itemType === ITEMTYPE.GEM && item.location === ITEMLOC.INVENTORY &&
            (dstLocation === ITEMLOC.INVENTORY || dstLocation === ITEMLOC.EQUIPPED_EQUIP)) {
            const target = this._data.findByLocSlot(dstLocation, dstLocInfo.slot);
            if (target && SOCKETABLE_ITEM_TYPES.includes(target.itemType) &&
                target.socketCount > 0 && !target.gemOption1) {
                // Raw server items[] indices: equip slots as-is, backpack +12.
                const targetSlot = dstLocation === ITEMLOC.INVENTORY ? dstLocInfo.slot + 12 : dstLocInfo.slot;
                netGame.gemItem(targetSlot, item.slotNo + 12);
                return;
            }
        }

        if (item.location === ITEMLOC.INVENTORY && dstLocation === ITEMLOC.EQUIPPED_PAT) {
            if (item.itemType === ITEMTYPE.RIDE_PART) {
                this._data.useItem(item, InventoryDialog.PAT_SLOTS[dstLocInfo.slot]);
            }
            return;
        }

        if (item.location === ITEMLOC.INVENTORY &&
            dstLocation === ITEMLOC.EQUIPPED_EQUIP &&
            item.itemType === ITEMTYPE.RIDE_PART) {
            return;
        }

        // Equip -> Equip does nothing
        if (
            item.location !== ITEMLOC.INVENTORY &&
            dstLocation !== ITEMLOC.INVENTORY
        ) {
            return;
        }

        // Equip or unquip item
        if (
            item.location === ITEMLOC.EQUIPPED_EQUIP ||
            dstLocation === ITEMLOC.EQUIPPED_EQUIP ||
            item.location === ITEMLOC.EQUIPPED_PAT ||
            dstLocation === ITEMLOC.EQUIPPED_PAT
        ) {
            srcSlot.use();
            return;
        }

        if (
            item.location === ITEMLOC.INVENTORY &&
            dstLocation === ITEMLOC.INVENTORY
        ) {
            const destination = 12 + dstLocInfo.slot;
            // Each 30-slot page is reserved for its item category. The
            // server validates both sides of the swap and sends a snapshot.
            if (Math.floor(item.slotNo / 30) === Math.floor(dstLocInfo.slot / 30)) {
                netGame.equipItem(destination, item.itemKey);
            }
            return;
        }

        console.warn("Unhandled _swapSlots", srcSlot, dstLocation);
    }

    _getItemSlot(location: any, id: any) {
        let slot = null;

        switch (location) {
            case ITEMLOC.INVENTORY:
                slot = this._inventorySlots[id];
                break;
            case ITEMLOC.EQUIPPED_EQUIP:
                // pakInventory sends the raw items[] index as slotNo for
                // equipment; _equipSlots uses that same index.
                slot = this._equipSlots[id];
                break;
            case ITEMLOC.EQUIPPED_AMMO:
                slot = this._ammoSlots[id];
                break;
            case ITEMLOC.EQUIPPED_PAT:
                slot = this._patSlots[InventoryDialog.PAT_SLOTS.indexOf(id + 135)];
                break;
            case ITEMLOC.EQUIPPED_COSTUME:
            default:
                console.warn("_getItemSlot unexpected location " + location);
        }

        return slot;
    }

    _update() {
        TooltipManager.hideTooltip();
        // Clear previous
        for (let i = 0; i < this._inventorySlots.length; ++i) {
            if (this._inventorySlots[i]) {
                this._inventorySlots[i].clear();
            }
        }

        for (let i = 0; i < this._equipSlots.length; ++i) {
            if (this._equipSlots[i]) {
                this._equipSlots[i].clear();
            }
        }
        for (let i = 0; i < this._ammoSlots.length; ++i) {
            if (this._ammoSlots[i]) {
                this._ammoSlots[i].clear();
            }
        }
        for (let i = 0; i < this._patSlots.length; ++i) {
            if (this._patSlots[i]) {
                this._patSlots[i].clear();
            }
        }

        // Set current
        const itemData = GDM.getNow("item_data");

        for (let i = 0; i < this._data.items.length; ++i) {
            const key = i;
            const item = this._data.items[key];
            if (!item) continue;
            const slot = this._getItemSlot(item.location, item.slotNo);

            if (slot) {
                slot.setItem(item);
            }
        }
        this._updatePatStats(itemData);
    }

    _updatePatStats(itemData: any) {
        const parts = [135, 136, 137, 138, 139].map((slot) => this._data.findBySlot(slot));
        const stats = parts.map((item) => item ? itemData.getPatStats(item.itemNo) : null);
        const types = new Set(stats.slice(0, 3).filter(Boolean).map((part: any) => part.subtype % 10));
        const type = types.size === 0 ? 'None' : types.size > 1 ? 'Mixed' :
            types.has(2) ? 'Castle Gear' : 'Cart';

        const complete = parts.slice(0, 3).every(Boolean);
        const speedParts = stats.filter((part: any) => part && part.speed > 0);
        const moveSpeed = complete && speedParts.length
            ? Math.floor(speedParts.reduce((product: number, part: any) => product * part.speed, 1)
                * 1000 / Math.pow(100, speedParts.length))
            : 0;
        // The server checks Weapon before Ability when selecting mounted attack stats.
        const weapon = stats[3] || stats[4];
        const characterStats = typeof MC !== 'undefined' ? MC?.calculatedStats : null;

        const values: Record<string, string | number> = {
            '.pat-type-value': type,
            '.pat-attack': weapon?.attackPower || 0,
            '.pat-defense': characterStats?.defense || 0,
            '.pat-move-speed': moveSpeed,
            '.pat-fuel': Math.max(0, Math.min(100, parts[1]?.itemLife || 0)) + '%',
            '.pat-magic-resist': characterStats?.magicDefense || 0,
            '.pat-attack-speed': weapon?.attackSpeed || 0,
        };
        for (const [selector, value] of Object.entries(values)) {
            this._element.find(selector).text(value);
        }
    }

    hide() {
        TooltipManager.hideTooltip();
        super.hide();
    }

    toggle() {
        TooltipManager.hideTooltip();
        super.toggle();
    }
}

function getItemLocationFromName(name: any) {
    let match;
    if ((match = name.match(/inventory-slot-([0-9]*)/))) {
        return { location: ITEMLOC.INVENTORY, slot: parseInt(match[1]) - 1 };
    } else if ((match = name.match(/equip-slot-([0-9]*)/))) {
        return { location: ITEMLOC.EQUIPPED_EQUIP, slot: parseInt(match[1]) };
    } else if ((match = name.match(/ammo-slot-([0-9]*)/))) {
        return { location: ITEMLOC.EQUIPPED_AMMO, slot: parseInt(match[1]) };
    } else if ((match = name.match(/pat-slot-([0-9]*)/))) {
        return { location: ITEMLOC.EQUIPPED_PAT, slot: parseInt(match[1]) };
    } else {
        return null;
    }
}

ui.InventoryDialog = InventoryDialog;

ui.inventoryDialog = function (inventory: any) {
    return new ui.InventoryDialog(inventory);
};
